import React from 'react';

import styles from '../../contractDetails.module.scss';

interface Terms {
  usage?: string;
  limitations?: string;
}

interface TermsAndConditionsProps {
  terms?: Terms;
}

export function TermsAndConditions( { terms }: TermsAndConditionsProps ) {
  if ( !terms || ( !terms.usage && !terms.limitations ) ) {
    return null;
  }

  return (
    <div className={ styles.termsSection }>
      <h4>Terms &amp; Conditions</h4>
      <div className={ styles.termsGrid }>
        { terms.usage && (
          <div className={ styles.termCard }>
            <h5>Usage</h5>
            <p>{ terms.usage }</p>
          </div>
        ) }
        { terms.limitations && (
          <div className={ styles.termCard }>
            <h5>Limitations</h5>
            <p>{ terms.limitations }</p>
          </div>
        ) }
      </div>
    </div>
  );
}
